import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import Media from '@ep/components/Media';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import { Body2, Body3, H4 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import Box from '@mui/material/Box';
import { DateTime } from 'luxon';
import React from 'react';

export interface PostCardProps {
  post: Gcms_Post;
}

const StyledMedia = styled(Media)`
  margin-top: 1.5rem;
  max-width: 52%;
  max-height: 30rem;
  overflow: hidden;
  @media (max-width: ${theme.breakpoints.optimalTablet + 400}px) {
    margin: 1.5rem;
    max-width: 100%;
  }
`;

const StyledH4 = styled(H4)`
  text-align: left;
  padding-right: 1.2rem;
  margin-top: 0.5rem;
  font-size: 2.3rem;
  color: ${theme.colors.duskBlue};
`;

const StyledBody3 = styled(Body3)`
  color: ${theme.colors.duskBlue};
  font-size: 1.3rem;
  font-family: ${theme.typography.secondaryFont.extraBold};
  text-align: left;
  margin-top: 1.2rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
`;

const Date = styled(Body3)`
  color: ${theme.colors.duskBlue};
  font-size: 1rem;
  font-family: ${theme.typography.secondaryFont};
  text-align: left;
  margin-top: 1.5rem;
  text-transform: uppercase;
`;

const StyledBody2 = styled(Body2)`
  padding-right: 1.2rem;
  text-align: left;
`;

const Texts = styled.div`
  width: 45%;
  float: left;
  display: flex;
  flex-direction: column;
  padding-left: 1rem;

  @media (max-width: ${theme.breakpoints.optimalTablet + 400}px) {
    float: none;
    width: 100%;
  }
`;

const StyledCard = styled(Box)`
  margin: 0px;
  padding: 0px;
  width: 100%;
  background-color: none;
  :not(:last-of-type) {
    margin-right: 3rem;
  }
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  width: 6rem;
  margin-top: 1rem;
  margin-left: 0;
  text-align: left;
  @media (max-width: ${theme.breakpoints.optimalTablet + 400}px) {
    margin-bottom: 1rem;
  }
`;

const TitleLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

function PostCard({ post }: PostCardProps) {
  const displayDate = DateTime.fromISO(post.displayDate);

  return (
    <StyledCard>
      <Texts>
        {post.postType && (
          <StyledBody3>EP {post.postType.replace(/_/g, ' ')}</StyledBody3>
        )}
        <Date>{displayDate.toLocaleString(DateTime.DATE_FULL)}</Date>
        <TitleLink to={'/' + post.slug}>
          <StyledH4>{post.title}</StyledH4>
        </TitleLink>
        <StyledBody2>{post.description}</StyledBody2>
        <StyledSeeMoreLink
          to={'/' + post.slug}
          label={post.postType != 'Master_Series' ? 'More' : 'Watch'}
        />
      </Texts>
      <Link to={'/' + post.slug}>
        <StyledMedia media={post.featuredImage!} aspectRatio={1} cover lazy />
      </Link>
      <CardFooter></CardFooter>
    </StyledCard>
  );
}

export default PostCard;
